import MainPageGestaoSicarf from '@/screens/gestaoSicarf/MainPage'
const gestaoSicarf = [
  {
    path: '/gestaoSicarf',
    name: 'gestaoSicarf',
    component: MainPageGestaoSicarf,
    meta: {
      isPublic: false
    },
    children: [
    ]
  }

]

export default gestaoSicarf



// WEBPACK FOOTER //
// ./src/router/gestaoSicarf.js